<template>
  <div class="total bgps flex fd">
    <theader />
    <div class="content f1 flex fd">
      <div class="left">
        <div class="top">
          <div class="zuo">
            <div style="height: 47%;width: 31%;" class="bluebg">
              <div class='top-title'>
                <longbluetitle :titlearr="['安全文明情况']" />
                <el-tooltip popper-class='situation-popper' class="item" effect="dark" :content="tipMap['安全文明情况']" placement="bottom-end">
                  <img class="img-tip" src="@/assets/image/situation/感叹@2x.png" alt="">
                </el-tooltip>
              </div>
              <div v-if='Object.keys(securityData).length'>
                <div class="imgecbox" >
                  <apngView width="85%" height='100%' :stopFram='securityData.coverRate' :src="require('@/assets/image/situation/仪表盘.png')"></apngView>

                  <!-- <img src="../assets/image/situation/仪表盘@2x.png" alt style="max-width: 80%;height: auto;" /> -->
                  <div class="textbox">
                    <countTo ref="countTo1" :startVal="0" :endVal="+securityData.coverRate||0" :duration="3000"
                            :autoplay="true"></countTo> %
                  </div>
                </div>
                <div class="divbox1" style="font-family: AlibabaPuHuiTi_2_55_Regular;font-size: .875rem;color: #BBC6D6;">
                <span  style="display: flex;align-items: center;font-family: AlibabaPuHuiTi_2_55_Regular;font-size: .875rem;color: #F3AE42;">
                  <img :src="computedArrow(securityData.updownFlag)"  style="width: 1.125rem;" />
                  <span   style="width: 1.125rem;" v-if="(securityData.updownFlag)!==2" >{{securityData.updownNumber  }}</span>
                  <span v-else  style="color: #D9E7FF;">持平</span>
                </span>
                <span style="margin-left: .625rem;">培训覆盖率</span>
              </div>
              </div>
              <noData v-else></noData>
            </div>
            <div style="height: 47%;width: 64%;" class="bluebg">

              <div class='top-title'>
                <longbluetitle :titlearr="['项目进度态势']" />
                <el-tooltip popper-class='situation-popper' class="item" effect="dark" :content="tipMap['项目进度态势']" placement="bottom-end">
                  <img class="img-tip" src="@/assets/image/situation/感叹@2x.png" alt="">
                </el-tooltip>
              </div>
              <div class="projetbox" v-if='Object.keys(projectProgressData).length'>
                <div class="top">
                  <div class="jindu">
                    <p>项目总体进度</p>
                    <div class="jindutiao">
                      <div class="chang" :style="`width: ${projectProgressData.progress}%;`"></div>
                      <div class="dian" :style="`left:${projectProgressData.progress - 1}%;`"></div>
                    </div>
                    <p style="color: #DB9625;">
                      <span style="font-size: 1.625rem;font-family: AlibabaPuHuiTi_2_85_Bold;font-weight: 600;">
                        <countTo ref="countTo2" :startVal="0" :endVal="+projectProgressData.progress||0" :duration="3000"
                                 :autoplay="true"></countTo>
                      </span>
                      <font>%</font>
                    </p>
                  </div>
                  <div class="chidren-jindu">
                    <div class='arrow arrow-left' @click="arrowBtn('left')"
                         :src="require('@/assets/image/situation/三角形@2x.png')"></div>
                    <img />
                    <div class="children-jindu-wrap">
                      <p class='text-children'>{{ projectList.unit_project_name }}</p>
                      <div class="jindutiao">
                        <div class="chang" :style="`width: ${projectList.progress}%;`"></div>
                        <div class="dian" :style="`left:${projectList.progress - 1}%;`"></div>
                      </div>
                      <p style="color: #DB9625;">
                        <span style="font-size: 1.625rem;font-family: AlibabaPuHuiTi_2_85_Bold;font-weight: 600;">
                          <countTo ref="countTo3" :startVal="0" :endVal="+projectList.progress ||0" :duration="3000"
                                   :autoplay="true"></countTo>
                        </span>
                        <font>%</font>
                      </p>
                    </div>
                    <div @click="arrowBtn('right')" class='arrow arrow-right'
                         :src="require('@/assets/image/situation/三角形@2x.png')"></div>
                  </div>
                </div>
                <div class="bottom">
                  <div class="jindu" v-for="(v, i) in projectList.children" :key="i">
                    <div class="biaoti">
                      <p style="font-size: .75rem;">{{ v.sub_project_name }}</p>
                      <p>
                        <span
                            style="font-family: AlibabaPuHuiTi_2_85_Bold;font-size: 1rem;color: #0BF9FE;">{{ v.progress }}</span>
                        <font>%</font>
                      </p>
                    </div>
                    <div class="jindutiao">
                      <div class="chang" :style="`width: ${v.progress}%;`"
                           style="background: linear-gradient( 270deg, #00d5ff 0%, rgba(0,192,254,0) 100%);"></div>
                      <div class="dian" :style="`left: ${v.progress - 1}%;`" style="background: #00E7FE;"></div>
                    </div>
                  </div>
                </div>
                <div class="page">
                  {{ currentPage }}/{{ projectProgressData.children && projectProgressData.children.length || 0 }}
                </div>
              </div>
              <noData v-else></noData>
            </div>
            <div style="height: 48%;width: 31%;" class="bluebg">
              <div class='top-title'>
                <longbluetitle :titlearr="['AI巡检态势']" />
                <el-tooltip popper-class='situation-popper' class="item" effect="dark" :content="tipMap['AI巡检态势']" placement="bottom-end">
                  <img class="img-tip" src="@/assets/image/situation/感叹@2x.png" alt="">
                </el-tooltip>
              </div>
              <div  class="AIbox">
                <div class="top">
                  <div v-for="(v, i) in aiList" :key="i">
                    <p style="font-family: AlibabaPuHuiTi_2_55_Regular;font-size: .8125rem;color: #D9E7FF;">{{ v.name }}
                    </p>
                    <p style="color: #0BF9FE;">
                      <span style="font-family: AlibabaPuHuiTi_2_85_Bold;font-size: 1.5rem;">
                        <countTo ref="countTo25" :startVal="0"
                                 :endVal="aiInspectionData[v.num] ? +aiInspectionData[v.num] : 0" :duration="3000"
                                 :autoplay="true"></countTo>

                      </span> <span v-if="v.isRate"> %</span>
                    </p>
                    <p style="display: flex;align-items: center;">
                      <span :style='computedTextColor(aiInspectionData[v.upFlag])' v-if="(aiInspectionData[v.upFlag])!==2">{{ aiInspectionData[v.up]>0 ? '+'+aiInspectionData[v.up] : aiInspectionData[v.up] }}</span>
                      <span  v-else>持平</span>
                      <img :src="computedArrow(aiInspectionData[v.upFlag]) " alt style="width: 1.125rem;" />
                      <!-- <i :class="v.icon"></i> -->
                    </p>
                  </div>
                </div>
                <div class="bot" v-if='Object.keys(aiInspectionData).length'>
                  <refreshImg :startTime='4000'   :flag='aiInspectionData.problemUpdownFlag' imageSize='小' :duration='20000'></refreshImg>

                </div>
                <noData v-else></noData>
              </div>

            </div>
            <div style="height: 48%;width: 31%;" class="bluebg">
              <div class='top-title'>
                <longbluetitle :titlearr="['工程车辆']" />
                <el-tooltip popper-class='situation-popper' class="item" effect="dark" :content="tipMap['工程车辆']" placement="bottom-end">
                  <img class="img-tip" src="@/assets/image/situation/感叹@2x.png" alt="">
                </el-tooltip>
              </div>
              <div class="carbox">
                <div class="top" style="margin-bottom: 0.6rem">
                  <div v-for="(v, i) in carList" :key="i">
                    <p style="font-family: AlibabaPuHuiTi_2_55_Regular;font-size: .8125rem;color: #D9E7FF;">{{ v.name }}
                    </p>
                    <p style="color: #0BF9FE;margin-left: -1.875rem;margin-top: .3125rem;">
                      <span style="font-family: AlibabaPuHuiTi_2_85_Bold;font-size: 1.625rem;">
                        <countTo ref="countTo4" :startVal="0" :endVal="carData[v.num] ? +carData[v.num] : 0"
                                 :duration="3000" :autoplay="true"></countTo>
                      </span>
                    </p>
                  </div>
                </div>
                <div class="bot"  v-if='Object.keys(carData.list).length'>
                  <table
                      style="width: 100%;padding: 0 15px;height: 100%;border-collapse: collapse;font-family: AlibabaPuHuiTi_2_55_Regular;font-size: .875rem;">
                    <tr v-if="carData.list" v-for="(v, i) in carData.list" :key="i" class='car-row'
                        :style="`background:${i % 2 !== 0 ? '' : '#02284A'}`">
                      <td>{{ v.showName }}</td>
                      <td>{{ v.driver }}</td>
                      <td :class="v.is_running ? 'inwork' : 'outwork'">{{ v.is_running ? '进场' : '出场' }}</td>
                    </tr>
                  </table>
                </div>
                <noData v-else></noData>
              </div>

            </div>
            <div style="height: 48%;width: 31%;" class="bluebg">
              <div class='top-title'>
                <longbluetitle :titlearr="['起重机械']" />
                <el-tooltip popper-class='situation-popper' class="item" effect="dark" :content="tipMap['起重机械']" placement="bottom-end">
                  <img class="img-tip" src="@/assets/image/situation/感叹@2x.png" alt="">
                </el-tooltip>
              </div>
              <div class="carbox">
                <div class="top" style="margin-bottom: 0.6rem">
                  <div v-for="(v, i) in qiList" :key="i">
                    <p style="font-family: AlibabaPuHuiTi_2_55_Regular;font-size: .8125rem;color: #D9E7FF;">{{ v.name }}
                    </p>
                    <p style="color: #0BF9FE;margin-left: -1.875rem;margin-top: .3125rem;">
                      <span style="font-family: AlibabaPuHuiTi_2_85_Bold;font-size: 1.625rem;">
                        <countTo ref="countTo5" :startVal="0"
                                 :endVal="liftingMachineryData[v.num] ? +liftingMachineryData[v.num] : 0" :duration="3000"
                                 :autoplay="true"></countTo>
                      </span>
                    </p>
                  </div>
                </div>
                <div class="bot"  v-if='Object.keys(liftingMachineryData.list).length'>
                  <table
                      style="width: 100%;padding: 0 15px;height: 100%;border-collapse: collapse;font-family: AlibabaPuHuiTi_2_55_Regular;font-size: .875rem;">
                    <tr v-if="liftingMachineryData.list" v-for="(v, i) in liftingMachineryData.list" :key="i"
                        class='car-row' :style="`background:${i % 2 !== 0 ? '' : '#02284A'}`">
                      <td>{{ v.showName || '' }}</td>
                      <td>{{ v.driver || '' }}</td>
                      <td :class="v.is_running ? 'inwork' : 'outwork'">{{ v.is_running ? '进场' : '出场' }}</td>
                    </tr>
                  </table>
                </div>
                <noData v-else></noData>
              </div>
            </div>
          </div>
          <div class="you">
            <div style="height: 42%;width: 96%;" class="bluebg">
              <div class='top-title'>
                <longbluetitle :titlearr="['人员出勤率']" />
                <el-tooltip popper-class='situation-popper' class="item" effect="dark" :content="tipMap['人员出勤率']" placement="bottom-end">
                  <img class="img-tip" src="@/assets/image/situation/感叹@2x.png" alt="">
                </el-tooltip>
              </div>
              <div class="peobox" v-if='Object.keys(attendanceData).length'>
                <div class="divbox" v-for="(v, i) in peoList" :key="i">

                  <div class="bot">
                    <div class="imgecbox1">
                      <div style=" width: 100%; overflow: hidden;">

                        <apngView style='margin:0 auto' width="8.336vw" height='100%' :stopFram='attendanceData[v.num]'
                                  :src="require('@/assets/image/situation/仪表盘.png')"></apngView>
                      </div>
                      <!-- <img src="../assets/image/situation/仪表盘.png" alt style="width: 65%;" /> -->
                      <div class="textbox">
                        <countTo class="count" ref="countTo6" :startVal="0" :endVal="+attendanceData[v.num]||0"
                                 :duration="3000" :autoplay="true"></countTo>
                        %
                      </div>
                    </div>
                  </div>
                  <div class="top">
<!--                    <div-->
<!--                        style="font-family: AlibabaPuHuiTi_2_55_Regular;font-size: .8125rem;color: #D9E7FF;display: flex;align-items: center;gap:4px;"-->
<!--                    >-->
<!--                      <span style="margin-right: 10px">{{v.name  }}</span>-->
<!--                      <img :src="computedArrow(attendanceData[v.upFlag]) " alt style="width: 1.125rem;" />-->
<!--                      <p :style='computedTextColor(attendanceData[v.upFlag])' v-if="(attendanceData[v.upFlag])!==2">-->
<!--                        {{attendanceData[v.up]}}-->
<!--                      </p>-->
<!--                      <p v-else>持平</p>-->
<!--                    </div>-->

                  </div>
                </div>
              </div>
              <noData v-else></noData>
            </div>
            <div style="height: 52%;width: 96%;" class="bluebg">
              <div class='top-title'>
                <longbluetitle :titlearr="['实名制设备']" />
                <el-tooltip popper-class='situation-popper' class="item" effect="dark" :content="tipMap['实名制设备']" placement="bottom-end">
                  <img class="img-tip" src="@/assets/image/situation/感叹@2x.png" alt="">
                </el-tooltip>
              </div>
              <div v-if="Object.keys(realNameDeviceData).length" class="shibox">
                <div class="top">
                  <div>
                    <div
                        style="font-family: AlibabaPuHuiTi_2_55_Regular;font-size: .8125rem;color: #D9E7FF;line-height: .8125rem;">
                      <span>在岗人员</span>
                      <img :src="computedArrow(realNameDeviceData.onWorkNumDifferenceFlag)" alt
                           style="width: 1.125rem;" />
                    </div>
                    <div>
                      <span style="color: #00d5ff;">
                        <countTo   style="font-family: AlibabaPuHuiTi_2_85_Bold;font-size: 1.5rem;color: #0BF9FE;" ref="countTo25" :startVal="0" :endVal="realNameDeviceData.onWorkNum" :duration="3000"
                                   :autoplay="true"></countTo>
                        <!-- <span
                            style="font-family: AlibabaPuHuiTi_2_85_Bold;font-size: 1.5rem;color: #0BF9FE;"
                        >{{realNameDeviceData.onWorkNum}}</span> -->
                      </span>
                      <font :style='computedTextColor(realNameDeviceData.onWorkNumDifferenceFlag)' v-if="(realNameDeviceData.onWorkNumDifferenceFlag)!==2">{{realNameDeviceData.onWorkNumDifference}}/小时</font>
                      <span v-else>持平</span>
                    </div>
                  </div>
                  <div>
                    <div
                        style="font-family: AlibabaPuHuiTi_2_55_Regular;font-size: .8125rem;color: #D9E7FF;line-height: .8125rem;">
                      <span>通道数量</span>
                    </div>
                    <div>
                      <span style="color: #00d5ff;">
                        <span style="font-family: AlibabaPuHuiTi_2_85_Bold;font-size: 1.5rem;color: #0BF9FE;">
                          <countTo ref="countTo7" :startVal="0" :endVal="realNameDeviceData.channelNum" :duration="3000"
                                   :autoplay="true"></countTo>

                        </span> 路
                      </span>
                    </div>
                  </div>
                </div>
                <div class="cneter">
                  <table
                      style="width: 100%;padding: 0 15px;height: 100%;border-collapse: collapse;font-family: AlibabaPuHuiTi_2_55_Regular;font-size: .875rem;">
                    <tr v-for="(v, i) in realNameDeviceData.workTypeList" :key="i" style="width: 100%;height: 20px;"
                        :style="`background:${i % 2 !== 0 ? '' : '#02284A'}`">
                      <td style="padding-left: 1.25rem;">{{ v.workType }}</td>
                      <td>{{ v.number }}人</td>
                      <td style="color: #09DAE3;">{{ v.ratio }}%</td>
                    </tr>
                  </table>
                </div>
                <div class="bot">
                  <div v-for="(v, i) in botlist" :key="i">
                    <div
                        style="font-family: AlibabaPuHuiTi_2_55_Regular;font-size: .8125rem;color: #D9E7FF;line-height: .8125rem;">
                      <span>{{ v.name }}</span>
                      <img :src="computedArrow(realNameDeviceData[v.upFlag])" alt style="width: 1.125rem;" />
                    </div>
                    <div style="color: #00d5ff;">
                      <span>
                        <span
                            style="font-family: AlibabaPuHuiTi_2_85_Bold;font-size: 1.5rem;color: #0BF9FE;">{{ realNameDeviceData[v.num] }}</span>
                      </span>
                      <font v-if="(realNameDeviceData[v.upFlag])!==2"
                            style="font-family: AlibabaPuHuiTi_2_55_Regular;font-size: .6875rem;color: #00FFE9;"
                      >{{realNameDeviceData[v.hour]}}/小时</font>
                      <span v-else style="color: #D9E7FF;">持平</span>
                    </div>
                  </div>
                </div>
              </div>
              <noData v-else></noData>
            </div>
          </div>
        </div>
        <div class="bottom">
          <div style="height: 98%;width: 21.7%;" class="bluebg">
            <div class='top-title'>
              <longbluetitle :titlearr="['安全巡检态势']" />
              <el-tooltip popper-class='situation-popper' class="item" effect="dark" :content="tipMap['安全巡检态势']" placement="bottom-end">
                <img class="img-tip" src="@/assets/image/situation/感叹@2x.png" alt="">
              </el-tooltip>
            </div>
            <div class="AIbox">
              <div class="top">
                <div v-for="(v, i) in anList" :key="i">
                  <p style="font-family: AlibabaPuHuiTi_2_55_Regular;font-size: .8125rem;color: #D9E7FF;">{{ v.name }}
                  </p>
                  <p style="color: #0BF9FE;">
                    <span style="font-family: AlibabaPuHuiTi_2_85_Bold;font-size: 1.5rem;">

                      <countTo ref="countTo8" :startVal="0" :endVal="  safetyInspectionData[v.num] ?+safetyInspectionData[v.num]:0 " :duration="3000"
                               :autoplay="true"></countTo>

                     </span> <span v-if="v.isRate">
                      %</span>
                  </p>
                  <p style="display: flex;align-items: center;">
                    <span v-if="(safetyInspectionData[v.upFlag])!==2" :style='computedTextColor(safetyInspectionData[v.upFlag])'>{{ safetyInspectionData[v.up] > 0 ?
                        '+' + safetyInspectionData[v.up] : safetyInspectionData[v.up] }}</span>
                    <span v-else>持平</span>
                    <img :src="computedArrow(safetyInspectionData[v.upFlag])" alt style="width: 1.125rem;" />
                    <!-- <i :class="v.icon"></i> -->
                  </p>

                </div>
              </div>
              <div class="bot"  v-if='Object.keys(safetyInspectionData).length'>
                <!-- <div id="echart2" class="charts f1"></div> -->
                <!-- <img
                  alt
                  :src="computedImgUrl('小',safetyInspectionData.problemUpdownFlag,6000,'安全巡检态势')"
                  style="width: 95%;margin-left: 3%;height:92%;margin-top: 8%;"
                /> -->
                <refreshImg :startTime='5000' :flag='safetyInspectionData.problemUpdownFlag' imageSize='小' :duration='20000'></refreshImg>
              </div>
              <noData v-else></noData>
            </div>

          </div>
          <div style="height: 98%;width: 21.7%;" class="bluebg">
            <div class='top-title'>
              <longbluetitle :titlearr="['质量巡检态势']" />
              <el-tooltip popper-class='situation-popper' class="item" effect="dark" :content="tipMap['质量巡检态势']" placement="bottom-end">
                <img class="img-tip" src="@/assets/image/situation/感叹@2x.png" alt="">
              </el-tooltip>
            </div>
            <div  class="AIbox">
              <div class="top">
                <div v-for="(v, i) in qualityList" :key="i">
                  <p style="font-family: AlibabaPuHuiTi_2_55_Regular;font-size: .8125rem;color: #D9E7FF;">{{ v.name }}
                  </p>
                  <p style="color: #0BF9FE;">
                    <span style="font-family: AlibabaPuHuiTi_2_85_Bold;font-size: 1.5rem;">
                      <countTo ref="countTo9" :startVal="0" :endVal="qualityInspectionData[v.num] ?+qualityInspectionData[v.num]:0" :duration="3000"
                               :autoplay="true"></countTo>
                    </span> <span v-if="v.isRate">
                      %</span>
                  </p>
                  <p style="display: flex;align-items: center;">
                    <span :style='computedTextColor(qualityInspectionData[v.upFlag])' v-if="(qualityInspectionData[v.upFlag])!==2">{{ qualityInspectionData[v.up] > 0 ?
                        '+' + qualityInspectionData[v.up] : qualityInspectionData[v.up] }}</span>
                    <span v-else>持平</span>
                    <img :src="computedArrow(qualityInspectionData[v.upFlag])" alt style="width: 1.125rem;" />
                    <!-- <i :class="v.icon"></i> -->
                  </p>
                </div>
              </div>
              <div class="bot" v-if='Object.keys(qualityInspectionData).length'>
                <!-- <div id="echart2" class="charts f1"></div> -->
                <!-- <img
                    alt
                    :src="computedImgUrl('小',qualityInspectionData.problemUpdownFlag)"

                    style="width: 95%;margin-left: 3%;height:92%;margin-top: 8%;"
                  /> -->
                <refreshImg :startTime='6000' :flag='qualityInspectionData.problemUpdownFlag' imageSize='小' :duration='20000'></refreshImg>

              </div>
              <noData v-else></noData>
            </div>


          </div>
          <div style="height: 98%;width: 52%;" class="bluebg">
            <div class='top-title'>
              <longbluetitle :titlearr="['气候态势']" />
              <el-tooltip  popper-class='situation-popper' class="item" effect="dark" :content="tipMap['气候态势']" placement="bottom-end">
                <img class="img-tip" src="@/assets/image/situation/感叹@2x.png" alt="">
              </el-tooltip>
            </div>
            <div v-if='Object.keys(weatherData).length' class="wartbox">
              <div class="top">
                <div v-for="(v, i) in wartList" :key="i">
                  <p style="display: flex;align-items: center;">
                    <span style="font-family: AlibabaPuHuiTi_2_55_Regular;font-size: .8125rem;color: #D9E7FF;">{{ v.name
                      }}</span>
                    <font :style='computedTextColor(weatherData[v.upFlag])' style="display: flex;align-items: center;">
                      <span v-if="(weatherData[v.upFlag])!==2">{{weatherData[v.up] }}</span>
                      <span v-else>持平</span>
                      <img  :src="computedArrow(weatherData[v.upFlag]) " alt style="width: 1.125rem;" />

                    </font>
                  </p>
                  <p style="display: block; color: #0BF9FE;">
                    <span style="font-family: AlibabaPuHuiTi_2_85_Bold;font-size: 1.5rem;">
                      <countTo ref="countTo10" :startVal="0" :endVal=" weatherData[v.num]" :duration="3000"
                               :autoplay="true"></countTo>
                     </span>
                    <span v-if="v.name == '温度'">℃</span>
                    <span v-if="v.name == '湿度'">%</span>
                    <span v-if="v.name == '风力'">级</span>

                  </p>
                </div>
              </div>
              <div class="bot">
                <refreshImg :startTime='7000' :flag='weatherData.temperatureUpdownFlag' imgSize='大' :duration='20000'></refreshImg>

                <!-- <apngView width='100%' height="100%" :src="require('@/assets/image/situation/大图表上升.png')" /> -->
              </div>
            </div>
            <noData v-else></noData>
          </div>
        </div>
      </div>
      <div class="right">
        <div style="height:32%;width: 98%;" class="bluebg">
          <div class='top-title'>
            <longbluetitle :titlearr="['材料采收态势']" />
            <el-tooltip popper-class='situation-popper' class="item" effect="dark" :content="tipMap['材料采收态势']" placement="bottom-end">
              <img class="img-tip" src="@/assets/image/situation/感叹@2x.png" alt="">
            </el-tooltip>
          </div>
          <div v-if='Object.keys(materiaAnalysislData).length' class="caibxo">
            <div class="mounthbox">
              <div class="left">
                <p>
                  <span
                      style="font-family: AlibabaPuHuiTi_2_55_Regular;font-size: .8125rem;color: #D9E7FF;">本月采购量</span>
                </p>
                <p style="color: #0BEBF2;">
                  <span class='ton-text'>
                    <countTo ref="countTo11" :startVal="0"
                             :endVal="materiaAnalysislData.purchaseAmountMonth ? +materiaAnalysislData.purchaseAmountMonth.totalTons : 0"
                             :duration="3000" :autoplay="true"></countTo>

                  </span>吨
                </p>
              </div>
              <div class="right" v-if="materiaAnalysislData.purchaseAmountMonth">
                <div class="jindu" v-for="item in materiaAnalysislData.purchaseAmountMonth.list">
                  <div class='dindu-type-name'>{{ item.typeName }}</div>
                  <div class="jindutiao">

                    <div class="chang" :style="`width: ${item.percent}%;`"
                         style="background: linear-gradient( 270deg, #0FCF89 0%, rgba(0,254,131,0) 100%);"></div>
                    <div class="dian" :style="`left:${item.percent - 1}%;`" style="background: #62FBC5;"></div>
                  </div>
                  <span>{{ item.tons }}吨</span>
                </div>
              </div>
            </div>
            <div class="mounthbox">
              <div class="left">
                <p>
                  <span
                      style="font-family: AlibabaPuHuiTi_2_55_Regular;font-size: .8125rem;color: #D9E7FF;">本月收料量</span>
                </p>
                <p style="color: #0BEBF2;">
                  <span class='ton-text'>

                    <countTo ref="countTo12" :startVal="0"
                             :endVal="materiaAnalysislData.receiveAmountMonth ? +materiaAnalysislData.receiveAmountMonth.totalTons : 0"
                             :duration="3000" :autoplay="true"></countTo>
                  </span>吨
                </p>
              </div>
              <div class="right" v-if="materiaAnalysislData.receiveAmountMonth"">
              <div class=" jindu" v-for="item in materiaAnalysislData.receiveAmountMonth.list">
                <div class='dindu-type-name'>{{ item.typeName }}</div>
                <div class="jindutiao">
                  <div class="chang" :style="`width: ${item.percent}%;`"
                       style="background: linear-gradient( 270deg, #0FCF89 0%, rgba(0,254,131,0) 100%);"></div>
                  <div class="dian" :style="`left:${item.percent - 1}%;`" style="background: #62FBC5;"></div>
                </div>
                <span>{{ item.tons }}吨</span>
              </div>
            </div>
          </div>
          <div class="mounthbox">
            <div class="left">
              <p>
                <span style="font-family: AlibabaPuHuiTi_2_55_Regular;font-size: .8125rem;color: #D9E7FF;">本月出料量</span>
              </p>
              <p style="color: #0BEBF2;">
                <span class='ton-text'>
                  <countTo ref="countTo13" :startVal="0"
                           :endVal="materiaAnalysislData.materialDeliveredAmountMonth ? +materiaAnalysislData.materialDeliveredAmountMonth.totalTons : 0"
                           :duration="3000" :autoplay="true"></countTo>
                </span>吨
              </p>
            </div>
            <div class="right" v-if="materiaAnalysislData.materialDeliveredAmountMonth">
              <div class="jindu" v-for="item in materiaAnalysislData.materialDeliveredAmountMonth.list">
                <div class='dindu-type-name'>{{ item.typeName }}</div>
                <div class="jindutiao">

                  <div class="chang" :style="`width: ${item.percent}%;`"
                       style="background: linear-gradient( 270deg, #0FCF89 0%, rgba(0,254,131,0) 100%);"></div>
                  <div class="dian" :style="`left:${item.percent - 1}%;`" style="background: #62FBC5;"></div>
                </div>
                <span>{{ item.tons }}吨</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="height: 30.5%;width: 48%;margin-top: 5px;" class="bluebg">
        <div class='top-title'>
          <longbluetitle :titlearr="['视频监控设备']" />
          <el-tooltip popper-class='situation-popper' class="item" effect="dark" :content="tipMap['视频监控设备']" placement="bottom-end">
            <img class="img-tip" src="@/assets/image/situation/感叹@2x.png" alt="">
          </el-tooltip>
        </div>
        <div v-if='Object.keys(videoData).length'  class="vedio-box">
          <div class="top">
            <div class='vedio-content'>
              <div class='vedio-item'>
                <div>球机数量</div>
                <div class='vedio-item-content'>
                  <img src="../assets/image/situation/球机@2x.png" alt="">
                  <span class='item-content-num'>
                    <countTo ref="countTo14" :startVal="0" :endVal="videoData.ballNumTotal" :duration="3000"
                             :autoplay="true"></countTo>

                  </span>
                </div>
              </div>
              <div class='vedio-item'>
                <div>在线情况</div>
                <div class='vedio-item-content'>
                  <span class='item-content-num'>

                    <countTo ref="countTo15" :startVal="0" :endVal="videoData.ballNumOnline" :duration="3000"
                             :autoplay="true"></countTo>
                    %
                  </span>
                  <!--                         <span>%</span>-->

                </div>
              </div>
              <div class='vedio-item'>
                <div>枪机数量</div>
                <div class='vedio-item-content'>
                  <img src="../assets/image/situation/枪机@2x.png" alt="">
                  <span class='item-content-num'>
                    <countTo ref="countTo16" :startVal="0" :endVal="videoData.gunNumTotal" :duration="3000"
                             :autoplay="true"></countTo>
                  </span>
                </div>
              </div>
              <div class='vedio-item'>
                <div>在线情况</div>
                <div class='vedio-item-content'>
                  <span class='item-content-num'>
                    <countTo ref="countTo17" :startVal="0" :endVal="videoData.gunNumOnline" :duration="3000"
                             :autoplay="true"></countTo>
                    %
                  </span>
                  <!--                         <span>%</span>-->

                </div>
              </div>
              <div class='vedio-item'>
                <div>鹰眼数量</div>
                <div class='vedio-item-content'>
                  <img src="../assets/image/situation/鹰眼@2x.png" alt="">
                  <span class='item-content-num'>
                    <countTo ref="countTo18" :startVal="0" :endVal="videoData.eagleNumTotal" :duration="3000"
                             :autoplay="true"></countTo>

                  </span>
                </div>
              </div>
              <div class='vedio-item'>
                <div>在线情况</div>
                <div class='vedio-item-content'>
                  <span class='item-content-num'>
                    <countTo ref="countTo19" :startVal="0" :endVal="videoData.eagleNumOnline" :duration="3000"
                             :autoplay="true"></countTo>
                    %
                  </span>
                  <!--                         <span>%</span>-->

                </div>
              </div>
            </div>
          </div>
        </div>
        <noData v-else></noData>

      </div>
      <div style="height: 30.5%;width: 48%;margin-top: 5px;" class="bluebg">
        <div class='top-title'>
          <longbluetitle :titlearr="['地磅监控设备']" />
          <el-tooltip popper-class='situation-popper' class="item" effect="dark" :content="tipMap['地磅监控设备']" placement="bottom-end">
            <img class="img-tip" src="@/assets/image/situation/感叹@2x.png" alt="">
          </el-tooltip>
        </div>
        <div class="dibangbox changeNodataImg">
          <div class="top">
            <p style="margin-bottom: .625rem;">
              <span style="font-family: AlibabaPuHuiTi_2_55_Regular;font-size: .8125rem;color: #D9E7FF;">今日过磅重量</span>
              <font
                  style="font-family: AlibabaPuHuiTi_2_55_Regular;font-size: .75rem;color: rgba(53, 149, 232, 1);display: flex;gap:7px;">
                <img :src="require('@/assets/image/situation/工程车@2x.png')" alt style="width:1.042vw;">

                {{ materialReceiveData.totalTons ? materialReceiveData.totalTons : '' }}车次
              </font>
            </p>
            <div>
              <span style="color: #0BF9FE;">
                <span
                    style="font-family: AlibabaPuHuiTi_2_85_Bold;font-size: 1.5rem;">
                  <countTo ref="countTo20" :startVal="0" :endVal="materialReceiveData.totalTons" :duration="3000"
                           :autoplay="true"></countTo>
                 </span>吨
              </span>
              <font
                  style="font-family: AlibabaPuHuiTi_2_55_Regular;font-size: .75rem;color: #FFA83B;display: flex;gap:7px;">
                +{{ materialReceiveData.updownNumber }}车次
                <img :src="require('../assets/image/situation/上升箭头.png')" alt style="width: 1.125rem;height: 1.125rem">
              </font>
            </div>
          </div>
          <div class="bot" v-if='Object.keys(materialReceiveData).length'>
          <noData style="height: 80%;" else></noData>
          </div>
        </div>
      </div>


      <div style="height: 34.5%;width: 48%;margin-top: 5px;" class="bluebg">
        <div class='top-title'>
          <longbluetitle :titlearr="['扬尘态势']" />
          <el-tooltip popper-class='situation-popper' class="item" effect="dark" :content="tipMap['扬尘态势']" placement="bottom-end">
            <img class="img-tip" src="@/assets/image/situation/感叹@2x.png" alt="">
          </el-tooltip>
        </div>
        <div  v-if='Object.keys(dustData).length'  class="AIbox">
          <div class="top">
            <div v-for="(v, i) in dustList" :key="i">
              <p style="font-family: AlibabaPuHuiTi_2_55_Regular;font-size: .8125rem;color: #D9E7FF;">{{ v.name }}</p>
              <p style="color: #0BF9FE;">
                <span style="font-family: AlibabaPuHuiTi_2_85_Bold;font-size: 1.5rem;">
                  <countTo ref="countTo21" :startVal="0" :endVal="dustData[v.num]" :duration="3000"
                           :autoplay="true"></countTo>
                 </span>
              </p>
              <p style="color: #DE9422;display: flex;align-items: center;">
                <span :style='computedTextColor(dustData[v.upFlag])' v-if="(dustData[v.upFlag])!==2">{{ dustData[v.up] }}</span>
                <span v-else style="color: #D9E7FF;">持平</span>
                <img :src="computedArrow(dustData[v.upFlag])" alt style="width: 1.125rem;" />

                <!-- <i :class="v.icon"></i> -->
              </p>
            </div>
          </div>
          <div class="bot">
            <!-- <img onload="playOnce(this)"  :src="require('../assets/image/situation/小下降.png') " alt    style="width: 92%;margin-left: 5%;"/> -->
            <!-- <img @load="playOnce" v-if="isShow" :src="computedImgUrl('小',)" alt    style="width: 92%;margin-left: 5%;" /> -->
            <!-- <apngView width='100%' height="100%" :src="require('@/assets/image/situation/小持平.png')" /> -->
            <refreshImg :startTime='8000' :flag='dustData.pm25UpdownFlag' imgSize='小' :duration='20000'></refreshImg>

          </div>
        </div>
        <noData v-else></noData>
      </div>
      <div style="height: 34.5%;width: 48%;margin-top: 5px;" class="bluebg">
        <div class='top-title'>
          <longbluetitle :titlearr="['噪音态势']" />
          <el-tooltip  popper-class='situation-popper' class="item" effect="dark" :content="tipMap['噪音态势']" placement="bottom-end">
            <img class="img-tip" src="@/assets/image/situation/感叹@2x.png" alt="">
          </el-tooltip>
        </div>
        <div  v-if='Object.keys(noiseData).length'  class="wartbox changeNodataImg">
          <div  class="top">
            <div>
              <p>
                <span style="font-family: AlibabaPuHuiTi_2_55_Regular;font-size: .8125rem;color: #D9E7FF;">噪音</span>
                <font style="color: #0BEBF2;"></font>
              </p>
              <p style="color: #0BF9FE;">
                <span style="font-family: AlibabaPuHuiTi_2_85_Bold;font-size: 1.5rem;color: #0BF9FE;">
                  <countTo ref="countTo22" :startVal="0" :endVal="noiseData.noiseNumber" :duration="3000"
                           :autoplay="true"></countTo>dB</span>
              </p>
              <p>
                <font :style='computedTextColor(noiseData.updownFlag)' style="display: flex;align-items: center;">
                  <span v-if="(noiseData.updownFlag)!==2">{{ noiseData.updownNumber }}</span>
                  <span v-else>持平</span>
                  <img :src="computedArrow(noiseData.updownFlag)" alt style="width: 1.125rem;" />
                </font>
              </p>
            </div>
            <div>

              <p style="font-family: AlibabaPuHuiTi_2_55_Regular;font-size: 1.125rem;color: #EF7626;">国控值</p>
              <p style="color: #0BF9FE;">
                <span style="font-family: AlibabaPuHuiTi_2_85_Bold;font-size: 1.5rem;color: #EF7626;">
                 {{noiseData.noiseThreshold}}
                 </span>
              </p>

            </div>
          </div>
          <div class="bot" v-if='Object.keys(noiseData).length'>
            <refreshImg :startTime='9000' :flag='noiseData.updownFlag' imgSize='小' imgName="噪音" :duration='20000'></refreshImg>
          </div>
        </div>
        <noData style="height: 75%;" v-else ></noData>
      </div>
    </div>
  </div>

  <tmenu />
  </div>
</template>

<script>
import noData from '@/components/common/noData.vue'
import countTo from 'vue-count-to'
import apngView from "@/components/common/ApngView.vue";
import refreshImg from '@/components/common/refreshImg.vue'
import {
  getWeatherSituation, getDustSituation, getNoiseSituation, getSecurityData, getMateriaAnalysislData,
  getCarData, getLiftingMachineryData, getMaterialReceiveData, getProjectProgressData, getRealNameDeviceData
  , getVideoSituation, getAttendanceSituation, getInspectionData
} from "@/utils/situationApi";

import SvgView from "@/components/SvgView.vue";
export default {
  components: { apngView, SvgView, refreshImg, countTo ,noData},
  data() {
    return {
      tipMap: {
        '安全文明情况': '培训覆盖率为已培训合格人数占参与培训人数的比值',
        '项目进度态势': '项目进度为各单位工程进度加权取平均',
        '人员出勤率': '项目人员的出勤率',
        '材料采收态势': '仅显示大宗用料TOP3的各自采购、收料、出料的占比情况',
        'AI巡检态势': '仅显示今日抓拍数据和置信度较昨日环比情况',
        '工程车辆': '工程车辆仅统计在册的工程车，并不能表示在场的作业车辆',
        '起重机械': '起重机械仅统计在册的机械车，并不能表示在场的作业车辆',
        '实名制设备': '在岗人员为已通过实名制通道进场但还未离场的人员',

        '视频监控设备': '视频监控设备包括监控球机、监控枪机和鹰眼，在线表示可查看监控视频流，离线表示设备通电异常或通信异常',
        '地磅监控设备': '项目若不存在地磅设备则过磅重量将以材料员记录的移库材料重量为准，车次与环比则为空',
        '安全巡检态势': '安全问题为本月发现的安全问题数量环比上月数量的变化情况，及时处理率为本月发现的安全问题处理及时情况，环比上月的及时处理情况',

        '质量巡检态势': '质量问题为本月发现的质量问题数量环比上月数量的变化情况，及时处理率为本月发现的安全问题处理及时情况，环比上月的及时处理情况',
        '气候态势': '气候的同比对象为地方气候监测值',
        '扬尘态势': '当前统计为PM2.5和PM1.0的实时值，同比对象为国控值',
        '噪音态势': '当前统计为噪音的实时值，同比对象为白天和夜间预警阈值',

      },
      videoList: [
        {
          name: "设备数量",
          num: 'cameraNum'
        },
        {
          name: "在线情况",
          num: 'cameraOnlineRate'
        }
      ],
      botlist: [
        {
          name: "进场人次",
          num: 'inNum',
          hour: 'inNumDifference',
          upFlag: 'inNumDifferenceFlag'
        },
        {
          name: "出场人次",
          num: 'exitNum',
          hour: 'exitNumDifference',
          upFlag: 'exitNumDifferenceFlag'
        }
      ],

      aiList: [
        {
          name: "抓拍数量",
          num: 'problemNum',
          up: 'problemUpdownNumber',
          upFlag: 'problemUpdownFlag',
        },
        {
          name: "置信度",
          num: 'dealRate',
          isRate: true,
          up: 'dealRateUpdownNumber',
          upFlag: 'dealRateUpdownFlag',
        }
      ],
      carList: [
        {
          name: "运渣车",
          num: 'slagCarNumber'
        },
        {
          name: "挖掘机",
          num: 'excavatorNumber'
        }
      ],
      carTab: [
        {
          car: "运渣车司机",
          name: "张磊",
          hour: 7
        },
        {
          car: "运渣车司机",
          name: "陈杰",
          hour: 8
        },
        {
          car: "运渣车司机",
          name: "吴刚毅",
          hour: 4
        }
      ],
      qiList: [
        {
          name: "塔吊作业数量",
          num: 'towerCraneNumber'
        },
        {
          name: "升降梯数量",
          num: 'liftNumber'
        }
      ],
      qiTab: [
        {
          car: "塔吊司机",
          name: "王俊尧",
          hour: 2
        },
        {
          car: "塔吊司机",
          name: "张蜀一",
          hour: 0
        }
      ],
      peoList: [
        {
          name: "出勤率",
          num: 'percentNumber',
          up: 'updownNumber',
          upFlag: 'updownFlag',
        },
      ],
      shitab: [
        {
          car: "钢筋工",
          name: 54,
          hour: 34
        },
        {
          car: "木工",
          name: 33,
          hour: 25
        },
        {
          car: "模板工",
          name: 20,
          hour: 16
        },
        {
          car: "电工",
          name: 18,
          hour: 11
        },
        {
          car: "挖车司机",
          name: 14,
          hour: 8
        }
      ],
      anList: [
        {
          name: "安全问题",
          num: 'problemNum',
          up: 'problemUpdownNumber',
          upFlag: 'problemUpdownFlag',
        },
        {
          name: "准确率",
          num: 'dealRate',
          isRate: true,
          up: 'dealRateUpdownNumber',
          upFlag: 'dealRateUpdownFlag',
        }
      ],
      qualityList: [
        {
          name: "质量问题",
          num: 'problemNum',
          up: 'problemUpdownNumber',
          upFlag: 'problemUpdownFlag',
        },
        {
          name: "及时处理率",
          num: 'dealRate',
          isRate: true,
          up: 'dealRateUpdownNumber',
          upFlag: 'dealRateUpdownFlag',
        }
      ],
      wartList: [
        {
          name: "温度",
          num: 'temperatureNumber',
          up: 'temperatureUpdownNumber',
          upFlag: 'temperatureUpdownFlag',
        },
        {
          name: "湿度",
          num: 'humidityNumber',
          up: 'humidityUpdownNumber',
          upFlag: 'humidityUpdownFlag',
        },
        {
          name: "风力",
          num: 'windSpeedNumber',
          up: 'windSpeedUpdownNumber',
          upFlag: 'windSpeedUpdownFlag',
        }
      ],
      dustList: [
        {
          name: "PM2.5",
          num: 'pm25Number',
          up: 'pm25UpdownNumber',
          upFlag: 'pm25UpdownFlag',

        },
        {
          name: "PM10",
          num: 'pm10Number',
          up: 'pm10UpdownNumber',
          upFlag: 'pm10UpdownFlag',

        }
      ],
      noiseData: {},
      dustData: {},
      weatherData: {},
      videoData: {},
      attendanceData: {},
      isShow: true,
      aiInspectionData: {},
      safetyInspectionData: {},
      qualityInspectionData: {},
      carData: {},
      liftingMachineryData: {},
      materialReceiveData: {},
      projectProgressData: {},
      currentPage: 1,
      projectList: {},
      securityData: {},
      materiaAnalysislData: {},
      realNameDeviceData: {}
    };
  },
  methods: {
    computedArrow(type) {
      type = type ? type : 0
      const typeMap = {
        1: '上升',
        0: '下降',
        2: '持平'
      }
      return `${require(`@/assets/image/situation/${typeMap[type]}箭头.png`)}`
    },
    FlatArrowContent(type) {
      type = 2 ? type : 0
      return `持平`;
    },
    computedTextColor(type) {
      const typeMap = {
        1: 'rgb(222, 148, 34)',
        0: 'rgb(11, 235, 242)',
        2: 'rgba(217, 231, 255, 1)'
      }
      return `color:${typeMap[type]}`
    },
    arrowBtn(type) {

      if (type === 'left') {
        if (this.currentPage === 1) return
        this.currentPage--
      } else {
        if (this.currentPage === this.projectProgressData.children.length) return
        this.currentPage++
      }
      this.projectList = this.projectProgressData.children[this.currentPage - 1]
    },
    setShow() {
      this.isShow = false;
      this.isShow = true;
      console.log(this.isShow, '切换展示')
      // this.$nextTick(()=>{


      // })
    },
    getNoiseData() {
      getNoiseSituation().then(res => {
        this.noiseData = res?.data || {}
      })
    },
    getDustData() {
      getDustSituation().then(res => {
        this.dustData = res?.data || {}
      })
    },
    getWeatherData() {
      getWeatherSituation().then(res => {
        this.weatherData = res?.data || {}
      })
    },
    getVideoData() {
      getVideoSituation().then(res => {
        this.videoData = res?.data || {}
      })
    },
    getAttendanceData() {
      getAttendanceSituation().then(res => {
        this.attendanceData = res?.data || {}
      })
    },
    getInspectionData() {
      const map = {
        'AI巡检态势': 'aiInspectionData',
        '安全巡检态势': 'safetyInspectionData',
        '质量巡检态势': 'qualityInspectionData',
      }
      getInspectionData().then(res => {
        const data = res?.data || []
        data.forEach(item => {
          this[map[item.type]] = item
        })
      })

    },
    getCarData() {
      getCarData().then(res => {
        this.carData = res?.data || {}
      })
    },
    getLiftingMachineryData() {
      getLiftingMachineryData().then(res => {
        this.liftingMachineryData = res?.data || {}
      })
    },
    getMaterialReceiveData() {
      getMaterialReceiveData().then(res => {
        this.materialReceiveData = res?.data || {}
      })
    },
    getProjectProgressData() {
      getProjectProgressData().then(res => {
        this.projectProgressData = res?.data || {}
        this.projectList = this.projectProgressData.children[this.currentPage - 1]|| []
      })
    },
    getSecurityData() {
      getSecurityData().then(res => {
        this.securityData = res?.data || {}
      })
    },
    getMateriaAnalysislData() {
      getMateriaAnalysislData().then(res => {
        this.materiaAnalysislData = res?.data || {}
      })
    },
    getRealNameDeviceData() {
      getRealNameDeviceData().then(res => {
        this.realNameDeviceData = res?.data || {}
      })
    }
  },
  created() {
    this.getDustData()
    this.getNoiseData()
    this.getWeatherData()
    this.getVideoData()
    this.getAttendanceData()
    this.getInspectionData()
    this.getCarData()
    this.getLiftingMachineryData()
    this.getMaterialReceiveData()
    this.getProjectProgressData()
    this.getSecurityData()
    this.getMateriaAnalysislData()
    this.getRealNameDeviceData()
  },
  mounted() {
    setInterval(() => {
      for (const refName in this.$refs) {
          const refElement = this.$refs[refName];
          if(refName.includes('countTo')){
            if(refElement.length){
              refElement.forEach(item=>{
                item.start()
              })
            }else{

              refElement.start&&refElement.start()
            }
          }
        }
    }, 20000)
  }
};
</script>

<style lang="scss" scoped>
.nodata{
  height: 86%;
}
.total {
  width: 100%;
  height: 100%;
  background: url("../assets/image/bgstaff.png") no-repeat;

  .content {
    width: 88%;
    height: 90%;
    margin-left: 12%;
    display: flex;
    flex-direction: row;
    margin-top: 1%;

    .charts {
      width: 100%;
      height: 100%;
    }

    .left {
      width: 65%;
      height: 100%;

      >.top {
        width: 100%;
        height: 65%;
        display: flex;
        flex-direction: row;

        .zuo {
          width: 70%;
          height: 100%;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-around;
        }

        .you {
          width: 30%;
          height: 100%;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-around;
        }
      }

      >.bottom {
        width: 100%;
        height: 35%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
      }
    }

    .right {
      width: 35%;
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
    }
  }
}

.bluebg {
  background: rgba(0, 25, 49, 0.5);
  box-shadow: inset 0px 0px 24px 0px rgba(72, 125, 163, 0.5);
  border-radius: 8px;
  border: 1px solid rgba(131, 166, 199, 0.3);
  backdrop-filter: blur(3px);
  position: relative;

  .projetbox {
    width: 100%;
    height: 80%;

    .top {
      width: 100%;

      .jindu {
        width: 100%;
        height: 1.36vw; //26px
        padding: 0 0.625rem;
        margin-bottom: 0.833vw;
        display: flex;
        justify-content: space-around;
        align-items: center;

        .jindutiao {
          width: 66%;
          height: 50%;
          font-size: 0.75rem;
          background: linear-gradient(270deg,
              #3c433e 0%,
              rgba(163, 181, 0, 0.338) 100%);
          border-radius: 100px;
          position: relative;

          .chang {
            transition: all 3s ease-in-out;
            height: 100%;
            background: linear-gradient(270deg,
                #de921f 0%,
                rgba(0, 254, 190, 0.168) 100%);
            border-radius: 100px;
          }

          .dian {
            transition: all 3s ease-in-out;
            width: 0.375rem;
            height: 0.9375rem;
            background: #ffc94a;
            box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
            border-radius: 0.1875rem;
            position: absolute;
            top: -2px;
          }
        }
      }

      .chidren-jindu {
        width: 100%;
        height: 1.16vw; //26px
        padding: 0 0.521vw;
        margin-bottom: 0.833vw;
        display: flex;
        justify-content: space-between;
        gap: 0.521vw;
        align-items: center;

        .arrow {
          width: 1.042vw;
          height: 0.521vw;
        }

        .arrow-left {
          background: url('@/assets/image/situation/下拉箭头默认.png');
          background-size: contain;
          transform: rotateZ(90deg);
        }

        .arrow-left:hover {
          background: url('@/assets/image/situation/下拉箭头高亮.png');

          background-size: contain;
        }

        .arrow-right {
          background: url('@/assets/image/situation/下拉箭头默认.png');
          background-size: contain;
          transform: rotateZ(-90deg)
        }

        .arrow-right:hover {
          background: url('@/assets/image/situation/下拉箭头高亮.png');
          background-size: contain;

        }

        .children-jindu-wrap {
          display: flex;
          justify-content: space-between;
          gap: 0.521vw;
          align-items: center;
          flex: 1;
          height: 100%;

          .text-children {
            font-size: 0.61vw;
            max-width: 5.21vw;
            text-overflow: ellipsis;
            overflow: hidden;
            text-wrap: nowrap;
          }

          .jindutiao {
            flex: 1;
            height: 50%;
            font-size: 0.75rem;

            background: linear-gradient(270deg,
                #3c433e 0%,
                rgba(163, 181, 0, 0.338) 100%);
            border-radius: 100px;
            position: relative;

            .chang {
              height: 100%;
              transition: all 2s ease-in-out;
              background: linear-gradient(270deg,
                  #de921f 0%,
                  rgba(0, 254, 190, 0.168) 100%);
              border-radius: 100px;
            }

            .dian {
              width: 0.375rem;
              height: 0.9375rem;
              transition: all 2s ease-in-out;
              background: #ffc94a;
              box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
              border-radius: 0.1875rem;
              position: absolute;
              top: -2px;
            }
          }
        }
      }
    }

    .bottom {
      width: 100%;
      max-height: 55%;
      height: 55%;
      overflow: auto;
      // background: red;
      padding: 0 10px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .jindu {
        width: 48%;
        height: 29%;
        margin-bottom: 0.3125rem;

        .biaoti {
          width: 100%;
          height: 70%;
          display: flex;
          justify-content: space-between;
          align-items: center;

          >p {
            font-family: AlibabaPuHuiTi_2_55_Regular;
            font-size: 10px;
            color: #d9e7ff;
            line-height: 20px;
            text-align: left;
            font-style: normal;

            span {
              font-family: AlibabaPuHuiTi_2_85_Bold;
              font-size: 12px;
              // color: #D9E7FF;
              line-height: 28px;
              text-align: center;
              font-style: normal;
              text-transform: none;
              // background: linear-gradient(to right, red, blue);
              background: linear-gradient(90deg,
                  #05a5e7 0%,
                  #52d9ff 69%,
                  #94deff 100%);
              -webkit-background-clip: text;
              background-clip: text;
              color: transparent;
            }

            font {
              background: linear-gradient(90deg,
                  #05a5e7 0%,
                  #52d9ff 69%,
                  #94deff 100%);
              -webkit-background-clip: text;
              background-clip: text;
              color: transparent;
            }
          }
        }

        .jindutiao {
          width: 100%;
          height: 20%;
          background: linear-gradient(270deg,
              #092966 0%,
              rgba(0, 75, 181, 0.99) 100%);
          border-radius: 100px;
          position: relative;
          margin-top: 0.125rem;

          .chang {
            height: 100%;
            transition: all 2s ease-in-out;
            background: linear-gradient(270deg,
                #00d5ff 0%,
                rgba(0, 192, 254, 0) 100%);
            border-radius: 100px;
          }

          .dian {
            width: 0.3125rem;
            height: 0.625rem;
            transition: all 2s ease-in-out;
            background: #00e7fe;
            box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
            border-radius: 3px;
            position: absolute;
            top: -0.125rem;
          }
        }
      }
    }

    .page {
      text-align: center;
    }
  }

  .peobox {
    width: 100%;
    height: 80%;
    display: flex;

    .divbox {
      height: 100%;
      flex: 1;
      position: relative;
      .top {
        position: absolute;
        bottom:5px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      .bot {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .caibxo {
    width: 100%;
    height: 85%;

    .mounthbox {
      width: 100%;
      height: 33.33%;
      display: flex;

      .left {
        width: 20%;
        height: 90%;
        padding-left: 1.825vw;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .ton-text {
          font-family: AlibabaPuHuiTi_2_85_Bold;
          font-size: 24px;
          color: #0BF9FE;
          line-height: 26px;
          text-align: left;
          font-style: normal;
        }
      }

      .right {
        width: 78%;
        height: 90%;
        padding: 0.3125rem 0;

        .jindu {
          width: 100%;
          height: 15%;

          display: flex;
          justify-content: space-around;

          align-items: center;

          .dindu-type-name {
            width: 10%;
            text-overflow: ellipsis;
            overflow: hidden;
            text-wrap: nowrap;
            margin-right: 8px;
            font-family: AlibabaPuHuiTi_2_55_Regular;
            font-size: 0.75rem;
            color: #bbc6d6;
          }

          span {
            font-family: AlibabaPuHuiTi_2_55_Regular;
            font-size: 0.75rem;
            color: #bbc6d6;
          }

          .jindutiao {
            width: 75%;
            height: 100%;
            font-size: 0.75rem;
            background: linear-gradient(270deg,
                #092966 0%,
                rgba(0, 75, 181, 0.99) 100%);
            border-radius: 6.25rem;
            position: relative;

            .chang {
              transition: all 0.5s;
              height: 100%;
              border-radius: 6.25rem;
            }

            .dian {
              transition: all 3s ease-in-out;
              width: 0.3125rem;
              height: 0.9375rem;
              background: #ffc94a;
              box-shadow: 0px 0.125rem 0.25rem 0px rgba(0, 0, 0, 0.5);
              border-radius: 0.1875rem;
              position: absolute;
              top: -1px;
            }
          }
        }
      }
    }
  }

  .AIbox {
    width: 100%;
    height: 85%;

    .top {
      width: 100%;
      display: flex;

      >div {
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }

    .bot {
      width: 100%;
      height: 60%;
    }
  }

  .vedio-box {
    .top {
      width: 100%;
      height: 100%;
      display: flex;

      .vedio-content {
        height: 100%;
        margin-top: 0.35vw;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        flex-direction: row;
        padding: 0 10%;
        row-gap: 1.042vw;

        .vedio-item {
          width: 45%;

          .vedio-item-content {
            margin-top: 5px;
            height: 2rem;
            display: flex;
            align-items: center;

            img {
              width: 22px;
              height: 22px;
              margin-right: 10px;
            }

            .item-content-num {
              margin-right: 2px;
              font-family: AlibabaPuHuiTi_2_85_Bold;
              font-size: 1.5rem;
              color: #0BF9FE;
              line-height: 26px;
              font-style: normal;
            }
          }
        }
      }
    }

  }

  .carbox {
    width: 100%;
    height: 85%;

    .top {
      width: 100%;
      display: flex;

      >div {
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }

    .bot {
      width: 100%;
      max-height: 75%;
      padding: 5%;
      overflow-y: scroll;

      .car-row {
        width: 100%;
        height: 1.667vw; //vw1.667 = 32px
        display: flex;
        justify-content: space-between;
        align-items: center;

        td {
          flex: 1;
        }

        :nth-child(2) {
          text-align: center;
        }

        :nth-child(3) {
          text-align: center;
        }
      }
    }
  }

  .shibox {
    width: 100%;
    height: 90%;

    .top {
      width: 100%;
      height: 25%;
      display: flex;

      >div {
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        >div {
          width: 70%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 0.3125rem;
        }
      }
    }

    .cneter {
      width: 100%;
      height: 40%;
      padding: 2%;
      overflow: auto;
      display: flex;
      justify-content: space-between;
      align-items: center;

      tr {
        :nth-child(2) {
          text-align: center;
        }

        :nth-child(3) {
          text-align: center;
        }
      }

      td {
        flex: 1;

      }

    }

    .bot {
      width: 100%;
      height: 30%;
      display: flex;

      >div {
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        >div {
          width: 70%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 0.3125rem;
        }
      }
    }
  }

  .dibangbox {
    width: 100%;
    height: 85%;

    .top {
      width: 100%;
      height: 40%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      >p {
        width: 80%;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
      }

      >div {
        width: 80%;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
      }
    }

    .bot {
      width: 100%;
      height: 60%;
      display: flex;
    }
  }

  .wartbox {
    width: 100%;
    height: 85%;

    .top {
      width: 100%;
      height: 30%;
      display: flex;

      >div {
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        >p {
          width: 70%;
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
        }
      }
    }

    .bot {
      width: 100%;
      height: 70%;
    }
  }

  .kongbox {
    width: 100%;
    height: 85%;
    display: flex;
    justify-content: center;
    align-items: center;

    >img {
      width: 40%;
      height: 40%;
    }
  }

  .divbox1 {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position:absolute;
    bottom:5px;
  }

  // .textbox{
  //   position: absolute;
  //   top: 52%;
  //   left: 40%;
  // }
  .imgecbox {
    width: 100%;
    position: relative;
    // background: url('../assets/image/situation/仪表盘@2x.png') no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;

    // background-size: 100% 100%;
    // background-position: 0 0;
    .textbox {
      font-family: SourceHanSansCN, SourceHanSansCN;
      font-weight: bold;
      font-size: 1.25rem;
      color: #ffffff;
      // margin-top: 5%;
      position: absolute;

    }
  }

  .imgecbox1 {
    width: 90%;
    height: 100%;
    position: relative;
    // background: url('../assets/image/situation/仪表盘@2x.png') no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;

    // background-size: 100% 100%;
    // background-position: 0 0;
    .textbox {
      font-family: SourceHanSansCN, SourceHanSansCN;
      font-weight: bold;
      font-size: 0.8125rem;
      color: #ffffff;
      // margin-top: 5%;
      position: absolute;
    }
  }

}

.top-title {
  display: flex;
  align-items: center;

  // padding-right: 0.833vw;//16px~~
  .img-tip {
    width: 1.042vw;
    height: 1.042vw; //20px
    transform: translateY(-0.3vw);
    position: absolute;
    right: 0.833vw;
  }
}

.inwork {
  color: #3595E8;
}

.outwork {
  color: #FFA71F;
}
</style>
<style >
.el-tooltip__popper.is-dark.situation-popper{
  width: 10.42vw;
;
  min-height: 3.13vw;
  background: rgba(22, 86, 145, 0.4);
  box-shadow: inset 0px 0px 34px 0px rgba(0, 96, 227, 0.66);
  border: 2px solid #2064A2;
  backdrop-filter: blur(4px);
  font-family: AlibabaPuHuiTi_2_55_Regular;
  font-size: 0.64vw;
  color: #FFFFFF;
  line-height: 1.042vw;
;
  text-align: left;
  font-style: normal;

}

.el-tooltip__popper .popper__arrow,
.el-tooltip__popper .popper__arrow::after {
  display: none !important;
}

.bot::-webkit-scrollbar,
.bottoma::-webkit-scrollbar,
.cneter::-webkit-scrollbar {
  width: 6px;
  /*
  background: linear-gradient( 270deg, #0F87FA 0%, rgba(0,192,254,0.99) 100%);
  border-radius: 3px; */
  opacity: 0.0;
}

.bot::-webkit-scrollbar-thumb,
.bottom::-webkit-scrollbar-thumb,
.cneter::-webkit-scrollbar-thumb {
  width: 6px;
  background: linear-gradient(270deg, rgb(15, 135, 250, 0.4) 0%, rgba(0, 192, 254, 0.4) 100%);
  border-radius: 3px;
  opacity: 0.4;
}

.bot::-webkit-scrollbar-track,
.bottom::-webkit-scrollbar-track,
.center::-webkit-scrollbar-track {

  -webkit-box-shadow: 0;
  border-radius: 0;
  opacity: 0.4;
}
</style>
